import { useEffect, useMemo } from "react";
import FixturesPage from "./components/FixturesPage";
import { TFacility } from "./Fixtures.types";
import { getDOMComponentDomain, getDOMComponentBaseName } from "helpers";
import { BrowserRouter, Route, Routes } from "react-router-dom";

type TFixtureProps = {
  rootElement: HTMLElement;
};

const mapContent = (content: any) => ({
  id: content.Id,
  title: content.Title,
  icon: content.Icon,
  richText: content.RichText,
  MediaContent: content.MediaContent ?? [],
});

function Fixtures({ rootElement }: TFixtureProps) {
  const data = rootElement?.getAttribute("data-input");
  const domain = getDOMComponentDomain(rootElement);
  const basename = getDOMComponentBaseName(rootElement);

  useEffect(() => {
    rootElement?.setAttribute("data-input", "");
    // eslint-disable-next-line
  }, []);

  const parsedData = data ? (JSON.parse(data as any) as any) : undefined;

  const facilities: TFacility[] = useMemo(() => {
    return (
      parsedData?.FacilityList?.map((item: any) => ({
        id: item.FacilityId,
        title: item.Title,
        index: item.Index,
        ContentTags: item.ContentTags ?? [],
        price: Number(item.FromPrice),
        description: item.Description,
        MediaList: item.MediaList ?? [],
        isSoldOut: item.OutOfStock,
        content: item.Content?.map(mapContent) ?? [],
        enquireLink: item.WimbledonEnquiryLink,
        wimbledonFacilitySelectLink: item.WimbledonFacilitSelectLink,
        isTicketOnlyFacility: item.IsTicketOnlyFacility,
        vatText: item.VatText ?? "",
      })) ?? []
    );
  }, [parsedData]);

  if (!data) {
    return <></>;
  }

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route
          path="/"
          element={
            <FixturesPage
              labels={{
                dynamicMap: parsedData.DynamicMap ?? "",
                viewBtn: parsedData.ViewText ?? "",
                soldOutText: parsedData.SoldOutText ?? "",
                downloadFAQs: parsedData.DownloadFAQs ?? "",
                downloadUrl: parsedData.DownloadLink,
                title: parsedData.Title ?? "",
                downloadIcon: parsedData.DownloadIcon ?? "",
                eventId: parsedData.EventXMSID,
                priceFormatText: parsedData.PriceFormatText ?? "",
                culture: parsedData.Culture ?? "en-UK",
                quickLinksText: parsedData.QuickLinksText ?? "",
                packageOptionsText: parsedData.PackageOptionsLabel ?? "",
                mostPopularText: parsedData.MostPopularText ?? "",
                limitedAvailabilityText:
                  parsedData.LimitedAvailabilityText ?? "",
                fromText: parsedData.FromLabel ?? "",
                vatText: parsedData.VatText ?? "",
                enquireText: parsedData.EnquireText ?? "",
                numberOfGuestsText: parsedData.NumberOfGuestsLabel ?? "",
                optionsText: parsedData.OptionsLabel ?? "",
                dateText: parsedData.DateText ?? "",
                noOfGuestsShortText: parsedData.NoOfGuestsShortText ?? "",
                pricePerPersonText: parsedData.PricePerPeson ?? "",
                quantityText: parsedData.QuantityText ?? "",
                enhanceYourExperienceText:
                  parsedData.EnhanceYourExperienceText ?? "",
                noPackageOptionsText: parsedData.NoPackageOptionsText ?? "",
                addToBasket: parsedData.AddToBasketLabel ?? "",
                totalText: parsedData.TotalLabel ?? "",
                guestsText: parsedData.GuestsText ?? "",
                facilityNavPriceFormatText:
                  parsedData.FacilityNavPriceFormatText ?? "",
                wimbledonPriceFormatText: "Price From £{{price}}pp",
                isWimbledon: parsedData.IsWimbledon,
                wimbledonScheduleLink: parsedData.WimbledonScheduleLink ?? "",
                scheduleOfPlayText: parsedData.ScheduleOfPlayText ?? "",
                selectFacilityLinkText: parsedData.SelectFacilityLinkText ?? "",
                selectTicketLinkText: parsedData.SelectTicketLinkText ?? "",
                basketSuccess: parsedData.BasketSuccess ?? "",
                basketError: parsedData.BasketError ?? "",
                eventName: parsedData.EventName,
                eventCategory: parsedData.EventCategory,
                sellingFast: "Selling fast",
                addToBasketErrorEmpty:
                  "Please update the quantity before adding to the basket.",
                enquireSelectText: "enquire",
                tbcDateText: parsedData.TBCDateLabel,
                tbcNoteText: parsedData.TBCNoteLabel,
                eventItemSitecoreID: parsedData.EventItemSitecoreID,
                moreinformationlabel: parsedData.MoreInformationLabel,
              }}
              facilities={facilities}
              domain={domain ?? ""}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default Fixtures;
